export function update(model, msg) {
  switch (msg.type) {
    case 'setMode':
      return { ...model, mode: msg.value };
    case 'setArea':
      return { ...model, area: msg.value };
    case 'setFrequency':
      return { ...model, frequency: msg.value };
    case 'toggleAddOn':
      return { ...model, addOns: { ...model.addOns, [msg.key]: !model.addOns[msg.key] } };
    case 'toggleLoyalty':
      return { ...model, loyalty: !model.loyalty };
    default:
      return model;
  }
}
